import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3 8.8125C3.41421 8.8125 3.75 9.14829 3.75 9.5625V13.5C3.75 13.9142 4.08579 14.25 4.5 14.25H13.5C13.9142 14.25 14.25 13.9142 14.25 13.5V9.5625C14.25 9.14829 14.5858 8.8125 15 8.8125C15.4142 8.8125 15.75 9.14829 15.75 9.5625V13.5C15.75 14.7426 14.7426 15.75 13.5 15.75H4.5C3.25736 15.75 2.25 14.7426 2.25 13.5V9.5625C2.25 9.14829 2.58579 8.8125 3 8.8125Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.99999 2.25C9.1989 2.25 9.38967 2.32902 9.53032 2.46967L12.9053 5.84467C13.1982 6.13756 13.1982 6.61244 12.9053 6.90533C12.6124 7.19822 12.1376 7.19822 11.8447 6.90533L9.74999 4.81066V11.4375C9.74999 11.8517 9.4142 12.1875 8.99999 12.1875C8.58578 12.1875 8.24999 11.8517 8.24999 11.4375V4.81066L6.15533 6.90533C5.86244 7.19822 5.38756 7.19822 5.09467 6.90533C4.80178 6.61244 4.80178 6.13756 5.09467 5.84467L8.46966 2.46967C8.61031 2.32902 8.80108 2.25 8.99999 2.25Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }